import { SATOSPortal } from "@/data-adapter/SATOSPortal";

export type UploadShiftCommentImageRequest = {
	file: File;
	companyId?: number | null;
};

export async function uploadShiftCommentImage({
	file,
	companyId,
}: UploadShiftCommentImageRequest): Promise<string> {
	if (!companyId) {
		throw new Error("Company ID is required for shift comment image upload");
	}

	return SATOSPortal.UploadShiftCommentImage({
		File: file,
		companyId,
	});
}
